import { useState, useEffect } from 'react'
import { debounce } from 'lib/debounce'
import { BREAK_LG, BREAK_SM } from '../lib/media-queries'

export const useWindowWidth = () => {
  const [width, setWidth] = useState(window.innerWidth)
  const debouncedHandler = debounce(onWindowResize, 50)

  useEffect(() => {
    window.addEventListener('resize', debouncedHandler)

    return () => window.removeEventListener('resize', debouncedHandler)
  })

  function onWindowResize() {
    setWidth(window.innerWidth)
  }

  const isMobile = width < BREAK_SM
  const isTablet = width >= BREAK_SM && width < BREAK_LG
  const isDesktop = width >= BREAK_LG

  return { isDesktop, isTablet, isMobile }
}
